export default __webpack_public_path__ + "static/media/shutterstock_559948462.c7ed1faf.webp";